import React from 'react';
import * as XLSX from 'xlsx';
import './ExamScoresModal.css';

export default function ExamScoresModal({ results, onClose }) {
  if (!results) return null;

  const { examTitle, passingMarks, totalSubmissions, data = [] } = results;

  // Function to export scores to Excel (.xlsx)
  const handleExportToExcel = () => {
    if (!data || data.length === 0) {
      alert('No candidate submission data available to export.');
      return;
    }

    // 1. Format data rows for Excel sheet
    const excelRows = data.map((item, index) => ({
      'S.No': index + 1,
      'Candidate Name': item.user?.name || 'N/A',
      'Email Address': item.user?.email || 'N/A',
      'Score Obtained': item.totalScore,
      'Max Score': item.maxScore,
      'Percentage': `${item.percentage}%`,
      'Status': item.isPassed ? 'PASSED' : 'FAILED',
      'Submitted At': item.submittedAt
        ? new Date(item.submittedAt).toLocaleString()
        : 'In Progress',
    }));

    // 2. Create Workbook and Worksheet
    const worksheet = XLSX.utils.json_to_sheet(excelRows);

    // Auto-adjust column widths
    const colWidths = [
      { wch: 6 },  // S.No
      { wch: 22 }, // Candidate Name
      { wch: 28 }, // Email Address
      { wch: 15 }, // Score Obtained
      { wch: 12 }, // Max Score
      { wch: 14 }, // Percentage
      { wch: 12 }, // Status
      { wch: 22 }, // Submitted At
    ];
    worksheet['!cols'] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Scores Report');

    // 3. Download File
    const sanitizedTitle = examTitle.replace(/[^a-zA-Z0-9]/g, '_');
    XLSX.writeFile(workbook, `${sanitizedTitle}_Scores.xlsx`);
  };

  return (
    <div className="ScoresModal-overlay" onClick={onClose}>
      <div className="ScoresModal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="ScoresModal-header">
          <div>
            <span className="ScoresModal-subtitle">ASSESSMENT REPORT</span>
            <h2>{examTitle}</h2>
          </div>
          <button className="ScoresModal-close-btn" onClick={onClose} title="Close">
            ✕
          </button>
        </div>

        {/* Stats Bar & Export Action */}
        <div className="ScoresModal-toolbar">
          <div className="ScoresModal-stats">
            <span>
              Total Candidates: <strong>{totalSubmissions}</strong>
            </span>
            <span>
              Passing Cutoff: <strong>{passingMarks} Marks</strong>
            </span>
          </div>
          <button className="ScoresModal-export-btn" onClick={handleExportToExcel}>
            📊 Export to Excel (.xlsx)
          </button>
        </div>

        {/* Table View */}
        {data.length === 0 ? (
          <p className="ScoresModal-empty">No candidate submissions recorded yet.</p>
        ) : (
          <div className="ScoresModal-table-wrapper">
            <table className="ScoresModal-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Candidate</th>
                  <th>Email</th>
                  <th>Score</th>
                  <th>Percentage</th>
                  <th>Status</th>
                  <th>Submitted At</th>
                </tr>
              </thead>
              <tbody>
                {data.map((res, index) => (
                  <tr key={res.submissionId || index}>
                    <td>{index + 1}</td>
                    <td>
                      <strong>{res.user?.name || 'Unknown User'}</strong>
                    </td>
                    <td>{res.user?.email || 'N/A'}</td>
                    <td>
                      <strong>{res.totalScore}</strong> / {res.maxScore}
                    </td>
                    <td>{res.percentage}%</td>
                    <td>
                      <span
                        className={`ScoresModal-badge ${
                          res.isPassed ? 'ScoresModal-badge-pass' : 'ScoresModal-badge-fail'
                        }`}
                      >
                        {res.isPassed ? 'PASSED' : 'FAILED'}
                      </span>
                    </td>
                    <td>
                      {res.submittedAt
                        ? new Date(res.submittedAt).toLocaleString()
                        : 'In Progress'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}